import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { MySharedService } from '../App/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare var $: any;
@Component({
    templateUrl: './AppViews/ReviewEmployee/ReviewSheet.html'
})

export class ReviewSheetComponent implements OnInit {
    userDetail: any;
    public constants: Constants;
    active = true;
    public showLoader = false;
    EmployeeReviewId:any = null;
    public ReviewEmployeeDetails:any  ={};
    public ReviewKRAList: any = [];
    public ReviewKPIList: any = [];

    public KRATotalEmployeeRating: any = 0.0;
    public KRATotalManagerRating: any = 0.0;
    public KPITotalWeightage: any = 0;
    public KPITotalEmployeeRating: any = 0.0;
    public KPITotalManagerRating: any = 0.0;
    public ReviewKPIModalList: any = [];
    public ReviewKPIKRA:any = {};
    public KPICheck :any = false;
    public employeeReviewComplete:any = false;
    public reviewerReviewComplete:any = false;
    public hrReviewComplete:any = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _route: Router) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ngOnInit() {
        this.EmployeeReviewId = JSON.parse(localStorage.getItem("EmployeeReviewId"));
        this.getReviewEmployeeDetails();
    }

    ngAfterViewInit() {

    }

    public getReviewEmployeeDetails() {
        this.showLoader = true;
        this._httpService.ajaxPost('ReviewEmployee/GetReviewEmployeeDetails', {"EmployeeReviewId":this.EmployeeReviewId}).subscribe(
            data => {
                this.ReviewEmployeeDetails = data["ReviewEmployee"][0];
                console.log('review', this.ReviewEmployeeDetails);
                if(this.ReviewEmployeeDetails.ReviewDateReviewer!=null)
                     this.reviewerReviewComplete=true;
                if(this.ReviewEmployeeDetails.ReviewDateEmployee!=null)
                     this.employeeReviewComplete=true;
                if(this.ReviewEmployeeDetails.ReviewDateHR!=null)
                     this.hrReviewComplete=true;

                this.ReviewKRAList = data["ReviewKRA"];
                this.ReviewKPIList = data["ReviewKPI"];
                this.setupKRAActions();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public setupKRAActions(){
        this.KRATotalEmployeeRating = 0.0;
        this.KRATotalManagerRating = 0.0;
        this.KPITotalWeightage = 0;
        this.KPITotalEmployeeRating = 0.0;
        this.KPITotalManagerRating = 0.0;
        var count = 1;
        this.ReviewKRAList.forEach(element => {
            var isKPI = false;
            var count1 = 1;
            this.ReviewKPIList.forEach(element1 => {
                if(element1.KRAId == element.KRAId){
                    isKPI = true;
                    element1.KRASequenceId = count;
                }
                element1.SequenceId = count1;
                count1 = count1+1;
            });
            element.IsEditKPI = isKPI;
            element.SequenceId = count;
            count = count+1;
            if(element.RatingEmployee != null && element.RatingEmployee != "")
            this.KRATotalEmployeeRating = parseFloat((parseFloat(this.KRATotalEmployeeRating) + parseFloat(element.RatingEmployee)*element.Weightage).toString()).toFixed(1);
            if(element.RatingManager != null && element.RatingManager != "")
            this.KRATotalManagerRating = parseFloat((parseFloat(this.KRATotalManagerRating) + parseFloat(element.RatingManager)*element.Weightage).toString()).toFixed(1);
        });
        if( this.KRATotalEmployeeRating != "")
        this.KRATotalEmployeeRating = parseFloat((this.KRATotalEmployeeRating/100).toString()).toFixed(1);
        if(this.KRATotalManagerRating != "")
        this.KRATotalManagerRating = parseFloat((this.KRATotalManagerRating /100).toString()).toFixed(1);

this.showKPIList();
    }

    public calculateTotalKRAEmployeeRating(){
        this.KRATotalEmployeeRating = 0.0;
        this.ReviewKRAList.forEach(element => {
            if(element.RatingEmployee != null && element.RatingEmployee != ""){
                if(element.RatingEmployee == ".")
                element.RatingEmployee = "0.0";
            this.KRATotalEmployeeRating = parseFloat((parseFloat(this.KRATotalEmployeeRating) + parseFloat(element.RatingEmployee)*element.Weightage).toString()).toFixed(1);
            }
        });

        if( this.KRATotalEmployeeRating != 0.0)
        this.KRATotalEmployeeRating = parseFloat((this.KRATotalEmployeeRating/100).toString()).toFixed(1);
        
    }

    public calculateTotalKRAManagerRating(){
        this.KRATotalManagerRating = 0.0;
        this.ReviewKRAList.forEach(element => {
            if(element.RatingManager != null && element.RatingManager != ""){
                if(element.RatingManager == ".")
                element.RatingManager = "0.0";
            this.KRATotalManagerRating = parseFloat((parseFloat(this.KRATotalManagerRating) + parseFloat(element.RatingManager)*element.Weightage).toString()).toFixed(1);
            }
        });

        if( this.KRATotalManagerRating != 0.0)
        this.KRATotalManagerRating = parseFloat((this.KRATotalManagerRating/100).toString()).toFixed(1);
        
    }

    showKPIList(){
        //this.ReviewKPIKRA = JSON.parse(JSON.stringify(this.ReviewKRAList.filter(m => m.SequenceId == KRASequenceId)[0]));
       // this.ReviewKPIModalList = JSON.parse(JSON.stringify(this.ReviewKPIList.filter(m => m.KRASequenceId == KRASequenceId)));
        // this.KPITotalWeightage = 0;
        // this.KPITotalEmployeeRating = 0.0;
        // this.KPITotalManagerRating = 0.0;
        // this.ReviewKPIModalList.forEach(element => {
        //     this.KPITotalWeightage = this.KPITotalWeightage + parseInt(element.Weightage);
        //     if(element.RatingEmployee != null && element.RatingEmployee != "")
        //     this.KPITotalEmployeeRating = parseFloat((parseFloat(this.KPITotalEmployeeRating) + parseFloat(element.RatingEmployee)*element.Weightage).toString()).toFixed(1);
        //     if(element.RatingManager != null && element.RatingManager != "")
        //     this.KPITotalManagerRating = parseFloat((parseFloat(this.KPITotalManagerRating) + parseFloat(element.RatingManager)*element.Weightage).toString()).toFixed(1);
        // });

       

        this.ReviewKRAList.forEach(item => {
            item.KPITotalWeightage = 0;
            item.KPITotalEmployeeRating = 0.0;
            item.KPITotalManagerRating = 0.0;
            item.ReviewKPIModalList=JSON.parse(JSON.stringify(this.ReviewKPIList.filter(m1 => m1.KRASequenceId == item.SequenceId)))
            this.ReviewKPIList.filter(m1 => m1.KRASequenceId == item.SequenceId).forEach(c => item.KPITotalWeightage += parseInt(c.Weightage));
            this.ReviewKPIList.filter(m1 => (m1.KRASequenceId == item.SequenceId && (m1.RatingEmployee != null && m1.RatingEmployee != "" ))).forEach(c => item.KPITotalEmployeeRating += (parseInt(c.RatingEmployee)*c.Weightage));
            this.ReviewKPIList.filter(m1 => (m1.KRASequenceId == item.SequenceId && (m1.RatingManager != null && m1.RatingManager != "" ))).forEach(c => item.KPITotalManagerRating += (parseInt(c.RatingManager)*c.Weightage));
            });


       // if( this.ReviewKRAList != "")
        //this.KPITotalEmployeeRating = parseFloat((this.KPITotalEmployeeRating/100).toString()).toFixed(1);
        //if(this.KPITotalManagerRating != "")
        //this.KPITotalManagerRating = parseFloat((this.KPITotalManagerRating /100).toString()).toFixed(1);
 this.ReviewKRAList.filter(m1 => (m1.KPITotalManagerRating != 0.0)).forEach(c => c.KPITotalManagerRating = parseFloat((c.KPITotalManagerRating /100).toString()).toFixed(1));
 this.ReviewKRAList.filter(m1 => (m1.KPITotalEmployeeRating != 0.0)).forEach(c => c.KPITotalEmployeeRating = parseFloat((c.KPITotalEmployeeRating /100).toString()).toFixed(1));       

    }

    public calculateTotalKPIEmployeeRating(template){

        // this.KPITotalEmployeeRating = 0.0;
        // this.ReviewKPIModalList.forEach(element => {
        //     if(element.RatingEmployee != null && element.RatingEmployee != ""){
        //         if(element.RatingEmployee == ".")
        //         element.RatingEmployee = "0.0";
        //     this.KPITotalEmployeeRating = parseFloat((parseFloat(this.KPITotalEmployeeRating) + parseFloat(element.RatingEmployee)*element.Weightage).toString()).toFixed(1);
        //     }
        // });

        // if( this.KPITotalEmployeeRating != 0.0)
        // this.KPITotalEmployeeRating = parseFloat((this.KPITotalEmployeeRating/100).toString()).toFixed(1);
    
        var tempTemplate =this.ReviewKRAList;
       
        if(template != null){
                    tempTemplate =this.ReviewKRAList.filter(m => m.SequenceId == template.KRASequenceId)[0];
                    tempTemplate.KPITotalEmployeeRating = 0.0;
                    tempTemplate.ReviewKPIModalList.forEach(element => {
                        if(!isNaN(element.RatingEmployee) && element.RatingEmployee !=null  && element.RatingEmployee !="")
                     tempTemplate.KPITotalEmployeeRating = parseFloat((parseFloat(tempTemplate.KPITotalEmployeeRating) + parseFloat(element.RatingEmployee)*element.Weightage).toString()).toFixed(1);
                        });

                        if( tempTemplate.KPITotalEmployeeRating != 0.0)
                        tempTemplate.KPITotalEmployeeRating = parseFloat((tempTemplate.KPITotalEmployeeRating/100).toString()).toFixed(1);
                        tempTemplate.RatingEmployee=tempTemplate.KPITotalEmployeeRating;
                    }
   
    
    }

    public calculateTotalKPIManagerRating(template){
        // this.KPITotalManagerRating = 0.0;
        // this.ReviewKPIModalList.forEach(element => {
        //     if(element.RatingManager != null && element.RatingManager != ""){
        //         if(element.RatingManager == ".")
        //         element.RatingManager = "0.0";
        //     this.KPITotalManagerRating = parseFloat((parseFloat(this.KPITotalManagerRating) + parseFloat(element.RatingManager)*element.Weightage).toString()).toFixed(1);
        //     }
        // });
        // if( this.KPITotalManagerRating != 0.0)
        // this.KPITotalManagerRating = parseFloat((this.KPITotalManagerRating/100).toString()).toFixed(1);
       
        var tempTemplate =this.ReviewKRAList;
        if(template != null){
            tempTemplate =this.ReviewKRAList.filter(m => m.SequenceId == template.KRASequenceId)[0];
            tempTemplate.KPITotalManagerRating = 0.0;
            tempTemplate.ReviewKPIModalList.forEach(element => {
                if(!isNaN(element.RatingManager) && element.RatingManager !=null  && element.RatingManager !="")
             tempTemplate.KPITotalManagerRating = parseFloat((parseFloat(tempTemplate.KPITotalManagerRating) + parseFloat(element.RatingManager)*element.Weightage).toString()).toFixed(1);
                });

                if( tempTemplate.KPITotalManagerRating != 0.0)
                tempTemplate.KPITotalManagerRating = parseFloat((tempTemplate.KPITotalManagerRating/100).toString()).toFixed(1);
                tempTemplate.RatingManager=tempTemplate.KPITotalManagerRating;
            }

    }

    public addUpdateReviewEmployeeKPI(){
        // if(this.validateReviewKPIDetails())
        // {
        //     this.ReviewKPIList = JSON.parse(JSON.stringify(this.ReviewKPIList.filter(m =>
        //         m.KRAId != this.ReviewKPIKRA.KRAId)));
        //     this.ReviewKPIModalList.forEach(element => {
        //         this.ReviewKPIList.push(element);
        //         this.ReviewKRAList.forEach(kra => {
        //             if(kra.KRAId == element.KRAId){
        //                 kra.IsEditKPI = true;
        //             }
        //         });
        //     });
        //     $('#addEditKPI').modal('hide');
        // }

        var check =1;
       
            
            this.ReviewKPIList=[];
        
            this.ReviewKRAList.forEach(element => {
                element.ReviewKPIModalList.forEach(item => {
                this.ReviewKPIList.push(item);
               });
               if(element.ReviewKPIModalList.length!=0)
                  element.IsEditKPI = true;
            });
            this.ReviewKRAList = JSON.parse(JSON.stringify(this.ReviewKRAList))
            this.ReviewKPIList = JSON.parse(JSON.stringify(this.ReviewKPIList));
            check=0;
    
    if(check==0){
        this.addUpdateReviewEmployee()
                }
             }




 
    validateaddupdateReviewKPIDetails(){
        var mandatory = "";
        var invalid = "";
        var functional = "";
        var  iskpidesc =false;
        var  iskpiweightage =false;
        var  iskpiManRate =false;
        var  iskpiManRateNo =false;
        var iskpiManComm =false;
      
        var  iskpiEmpRate =false;
        var  iskpiEmpRateNo =false;
        var iskpiEmpComm =false;
        if(this.ReviewKPIList.length != 0 )
        {
        
            this.ReviewKPIList.forEach(element => {
                if(element.KPIDescription == "" || element.KPIDescription == null)
                {
                    iskpidesc =true;
                   // mandatory = mandatory + "<br>KPI Description";
                }
                
                if(element.Weightage == "" || element.Weightage == null || element.Weightage == 0)
                {
                    iskpiweightage = true;
                  //  mandatory = mandatory + "<br>KPI Weightage";
                    
                }
                

                if(((this.userDetail.RoleId == this.constants.enumUserRole.Manager || this.userDetail.RoleId == this.constants.enumUserRole.Admin)&& this.userDetail.SiteUserId != this.ReviewEmployeeDetails.EmployeeId)&& (this.reviewerReviewComplete == true) )//manager and executive
                {
                    if((element.RatingManager == "" || element.RatingManager == null) && (!this.constants.numberOnlyPattern.test(element.RatingManager)))
                    {
                        iskpiManRate = true;
                      // $('#addEditKPI'+element.KRASequenceId).collapse('show');
                      //  mandatory = mandatory + "<br>KPI Manager Rating";
                    }
                    if( !this.constants.numberOnlyPattern.test(element.RatingManager) && element.RatingManager != 0)
                    {
                        iskpiManRateNo = true;
                      //  $('#addEditKPI'+element.KRASequenceId).collapse('show');
                      //  mandatory = mandatory + "<br>KPI Manager Rating should be number";
                    }
                   
                    if(element.CommentManager == "" || element.CommentManager == null)
                    {
                        iskpiManComm = true;
                       // $('#addEditKPI'+element.KRASequenceId).collapse('show');
                       // mandatory = mandatory + "<br>KPI Manager Comment";
                    }
                }

                if(((this.userDetail.RoleId == this.constants.enumUserRole.Manager || this.userDetail.RoleId == this.constants.enumUserRole.Admin)&& this.userDetail.SiteUserId != this.ReviewEmployeeDetails.EmployeeId)&& (this.reviewerReviewComplete == false) )//manager and executive
                {
                    
                    if( element.RatingManager != "" &&  element.RatingManager != null && !this.constants.numberOnlyPattern.test(element.RatingManager) && element.RatingManager != 0)
                    {
                        iskpiManRateNo = true;
                       // $('#addEditKPI'+element.KRASequenceId).collapse('show');
                      //  mandatory = mandatory + "<br>KPI Manager Rating should be number";
                    }
                   
                   
                }


                if((this.userDetail.RoleId == this.constants.enumUserRole.Executive || this.userDetail.SiteUserId == this.ReviewEmployeeDetails.EmployeeId) && (this.employeeReviewComplete == true) )//executive
                {
                    if((element.RatingEmployee == "" || element.RatingEmployee == null) && (!this.constants.numberOnlyPattern.test(element.RatingEmployee)))
                    {
                        iskpiEmpRate = true;
                       // $('#addEditKPI'+element.KRASequenceId).collapse('show');
                     //   mandatory = mandatory + "<br>KPI Employee Rating";
                    }
                    if(!this.constants.numberOnlyPattern.test(element.RatingEmployee) && element.RatingEmployee != 0)
                    {
                        iskpiEmpRateNo = true;
                      // $('#addEditKPI'+element.KRASequenceId).collapse('show');
                      //  mandatory = mandatory + "<br>KPI Manager Rating should be number";
                    }
                    
                    if(element.CommentEmployee == "" || element.CommentEmployee == null)
                    {
                        iskpiEmpComm = true;
                      // $('#addEditKPI'+element.KRASequenceId).collapse('show');
                      //  mandatory = mandatory + "<br>KPI Employee Comment";
                    }
                }

                if((this.userDetail.RoleId == this.constants.enumUserRole.Executive || this.userDetail.SiteUserId == this.ReviewEmployeeDetails.EmployeeId) && (this.employeeReviewComplete == false) )//executive
                {
                   
                    if( element.RatingEmployee != "" && element.RatingEmployee != null && !this.constants.numberOnlyPattern.test(element.RatingEmployee) && element.RatingEmployee != 0)
                    {
                        iskpiEmpRateNo = true;
                       // $('#addEditKPI'+element.KRASequenceId).collapse('show');
                      //  mandatory = mandatory + "<br>KPI Manager Rating should be number";
                    }
                    
                  
                }
            });
        }

    if(iskpidesc)
   {
       mandatory = mandatory + "<br>KPI Description";
   }
    if(iskpiweightage)
   {
        mandatory = mandatory + "<br>KPI Weightage";
   }
    if(iskpiManRate)
   {
    mandatory = mandatory + "<br>KPI Manager Rating";
   }
    if(iskpiManRateNo)
   {
    mandatory = mandatory + "<br>KPI Manager Rating should be number";
    }
    if(iskpiManComm)
    { 
    mandatory = mandatory + "<br>KPI Manager Comment";
    }
    if(iskpiEmpRate)
    {
        mandatory = mandatory + "<br>KPI Employee Rating";
    }
    if(iskpiEmpRateNo)
   {
    mandatory = mandatory + "<br>KPI Employee Rating should be number";
   } 
    if(iskpiEmpComm)
   {
    mandatory = mandatory + "<br>KPI Employee Comment";
   }  
        
        if (mandatory == "" && invalid == "" && functional == "") {
            return true;
        } else {
            
            var msg = "";
            if (mandatory != "") {
                msg = msg + "Please enter : " + mandatory;
                msg = msg + "<br>";
            }
            if (invalid != "") {
                msg = msg + "Please enter valid : " + invalid;
                msg = msg + "<br>";
            }
            if (functional != "") {
                msg = msg + functional;
            }
            this._sharedService.ShowMessage("error|" + msg);
        }
        return false;

    }
    // validateReviewKPIDetails(){
    //     var mandatory = "";
    //     var invalid = "";
    //     var functional = "";

    //     if(this.ReviewKPIModalList.length == 0)
    //     {
    //         mandatory = mandatory + "<br>KPI List";
    //     }
    //     else{
    //         this.ReviewKPIModalList.forEach(element => {
    //             if(element.KPIDescription == "" || element.KPIDescription == null)
    //             {
                   
    //                 mandatory = mandatory + "<br>KPI Description";
    //             }
                
    //             if(element.Weightage == "" || element.Weightage == null || element.Weightage == 0)
    //             {
    //                 mandatory = mandatory + "<br>KPI Weightage";
                    
    //             }
                

    //             if((this.userDetail.RoleId == this.constants.enumUserRole.Manager||this.userDetail.RoleId == this.constants.enumUserRole.Admin)&& this.userDetail.SiteUserId != this.ReviewEmployeeDetails.EmployeeId )//manager and executive
    //             {
    //                 if(element.RatingManager == "" || element.RatingManager == null)
    //                 {
    //                     mandatory = mandatory + "<br>KPI Manager Rating";
    //                 }
    //                 if( isNaN(element.RatingManager))
    //                 {
    //                     mandatory = mandatory + "<br>KPI Manager Rating should be number";
    //                 }
                   
    //                 if(element.CommentManager == "" || element.CommentManager == null)
    //                 {
    //                     mandatory = mandatory + "<br>KPI Manager Comment";
    //                 }
    //             }
    //             if(this.userDetail.RoleId == this.constants.enumUserRole.Executive || this.userDetail.SiteUserId == this.ReviewEmployeeDetails.EmployeeId)//executive
    //             {
    //                 if(element.RatingEmployee == "" || element.RatingEmployee == null)
    //                 {
    //                     mandatory = mandatory + "<br>KPI Employee Rating";
    //                 }
    //                 if( isNaN(element.RatingEmployee ))
    //                 {
    //                     mandatory = mandatory + "<br>KPI Manager Rating should be number";
    //                 }
                    
    //                 if(element.CommentEmployee == "" || element.CommentEmployee == null)
    //                 {
    //                     mandatory = mandatory + "<br>KPI Employee Comment";
    //                 }
    //             }
    //         });
    //     }

    //     if (mandatory == "" && invalid == "" && functional == "") {
    //         return true;
    //     } else {
            
    //         var msg = "";
    //         if (mandatory != "") {
    //             msg = msg + "Please enter : " + mandatory;
    //             msg = msg + "<br>";
    //         }
    //         if (invalid != "") {
    //             msg = msg + "Please enter valid : " + invalid;
    //             msg = msg + "<br>";
    //         }
    //         if (functional != "") {
    //             msg = msg + functional;
    //         }
    //         this._sharedService.ShowMessage("error|" + msg);
    //     }
    //     return false;

    // }

    public addUpdateReviewEmployee(){

        if(this.validateaddupdateReviewKPIDetails()&&this.validateReviewDetails()){
         
            // if(this.ReviewEmployeeDetails.IsLock == true){
            //     this.ReviewEmployeeDetails.StageId = this.constants.enumReviewEmployeeStatus.Locked;
            // }
            // else{
            //     this.ReviewEmployeeDetails.StageId = this.constants.enumReviewEmployeeStatus.Setup;
            // }
            this.ReviewEmployeeDetails.StageId = this.constants.enumReviewEmployeeStatus.Review;

            if(this.employeeReviewComplete == true && this.ReviewEmployeeDetails.ReviewDateEmployee == null)
            {
                this.ReviewEmployeeDetails.ReviewDateEmployee = moment().format('DD/MM/YYYY');
                this.ReviewEmployeeDetails.Score= 0;
            }
            if(this.reviewerReviewComplete == true && this.ReviewEmployeeDetails.ReviewDateReviewer == null)
            {
                this.ReviewEmployeeDetails.ReviewDateReviewer = moment().format('DD/MM/YYYY');
                this.ReviewEmployeeDetails.Score= this.KRATotalManagerRating;
            }
            if(this.hrReviewComplete == true && this.ReviewEmployeeDetails.ReviewDateHR == null)
            {
                this.ReviewEmployeeDetails.ReviewDateHR = moment().format('DD/MM/YYYY');
                this.ReviewEmployeeDetails.StageId = this.constants.enumReviewEmployeeStatus.Closed;
                this.ReviewEmployeeDetails.HRId =this.userDetail.SiteUserId;
                
            }

            this.showLoader = true;
            this._httpService.ajaxPost('ReviewEmployeeList/AddUpdateReviewEmployeeDetails', 
            {"ReviewEmployeeDetails":this.ReviewEmployeeDetails,
            "ReviewKRADetails":this.ReviewKRAList,
            "ReviewKPIDetails":this.ReviewKPIList,
            "UserId":this.userDetail.SiteUserId
        }).subscribe(
                data => {
                    this._sharedService.ShowMessage("success|Data Updated Successfully");
                    this._route.navigateByUrl("/reviewEmployeeList");
                },
                err => {
                    this.showLoader = false;
                    this._sharedService.ShowMessage(this.constants.globalError);
                },
                () => {
                    this.showLoader = false;
                }
            );
        }
    }

    validateReviewDetails(){
        var mandatory = "";
        var invalid = "";
        var functional = "";

        var  iskradesc =false;
        var  iskraweightage =false;
        var  iskraManRate =false;
        var  iskraManRateNo =false;
        var  iskraManComm =false;
        var  iskraEmpRate =false;
        var  iskraEmpRateNo =false;
        var  iskraEmpComm =false;

        if (this.ReviewEmployeeDetails.EmployeeId == null || this.ReviewEmployeeDetails.EmployeeId == "null") {
            mandatory = mandatory + "<br>Employee";
        }

        if (this.ReviewEmployeeDetails.PeriodId == null || this.ReviewEmployeeDetails.PeriodId == "null") {
            mandatory = mandatory + "<br>Period";
        }

        if (this.ReviewEmployeeDetails.CommentObjective == null || this.ReviewEmployeeDetails.CommentObjective == "") {
            mandatory = mandatory + "<br>Objective Comment";
        }

        if(this.ReviewKRAList.length == 0)
        {
            mandatory = mandatory + "<br>KRA List";
        }
        else {
            this.ReviewKRAList.forEach(element => {
                if(element.KRADescription == "" || element.KRADescription == null)
                {
                    iskradesc = true;
                   // mandatory = mandatory + "<br>KRA Description";
                }
                if(element.Weightage == "" || element.Weightage == null || element.Weightage == 0)
                {
                    iskraweightage =true;
                    //mandatory = mandatory + "<br>Weightage";
                }
              
                if(((this.userDetail.RoleId == this.constants.enumUserRole.Manager||this.userDetail.RoleId == this.constants.enumUserRole.Admin) && this.userDetail.SiteUserId != this.ReviewEmployeeDetails.EmployeeId  ) && (this.reviewerReviewComplete == true))//manager and executive
                {
                    if((element.RatingManager == "" || element.RatingManager == null) && (!this.constants.numberOnlyPattern.test(element.RatingManager)) )
                    {
                        iskraManRate = true ;
                    //    mandatory = mandatory + "<br>Manager Rating";
                    }
                    if( !this.constants.numberOnlyPattern.test(element.RatingManager)  && element.RatingManager != 0)
                    {
                        iskraManRateNo = true ;
                        //mandatory = mandatory + "<br> Manager Rating should be number";
                    }
                    if(element.CommentManager == "" || element.CommentManager == null)
                    {
                        iskraManComm = true ;
                       // mandatory = mandatory + "<br>Manager Comment";
                    }
                }

                if(((this.userDetail.RoleId == this.constants.enumUserRole.Manager||this.userDetail.RoleId == this.constants.enumUserRole.Admin) && this.userDetail.SiteUserId != this.ReviewEmployeeDetails.EmployeeId  ) && (this.reviewerReviewComplete == false))//manager and executive
                {
                   
                    if(element.RatingManager != "" && element.RatingManager != null && !this.constants.numberOnlyPattern.test(element.RatingManager)  && element.RatingManager != 0)
                    {
                        iskraManRateNo = true ;
                        //mandatory = mandatory + "<br> Manager Rating should be number";
                    }
                   
                }
                if((this.userDetail.RoleId == this.constants.enumUserRole.Executive || this.userDetail.SiteUserId == this.ReviewEmployeeDetails.EmployeeId)&& (this.employeeReviewComplete == true) )//executive
                {
                    if((element.RatingEmployee == "" || element.RatingEmployee == null) &&  (!this.constants.numberOnlyPattern.test(element.RatingEmployee)))
                    {
                        iskraEmpRate =true;
                       // mandatory = mandatory + "<br>Employee Rating";
                    }
                    if( !this.constants.numberOnlyPattern.test(element.RatingEmployee) && element.RatingEmployee != 0)
                    {
                        iskraEmpRateNo = true;
                       // mandatory = mandatory + "<br>KPI Manager Rating should be number";
                    }
                    if(element.CommentEmployee == "" || element.CommentEmployee == null)
                    {
                        iskraEmpComm =true;
                        //mandatory = mandatory + "<br>Employee Comment";
                    }
                }

                if((this.userDetail.RoleId == this.constants.enumUserRole.Executive || this.userDetail.SiteUserId == this.ReviewEmployeeDetails.EmployeeId)&& (this.employeeReviewComplete == false) )//executive
                {
                    
                    if(element.RatingEmployee != "" && element.RatingEmployee != null && (!this.constants.numberOnlyPattern.test(element.RatingEmployee)) && element.RatingEmployee != 0)
                    {
                        iskraEmpRateNo = true;
                       // mandatory = mandatory + "<br>KPI Manager Rating should be number";
                    }
                   
                }
            });
        }

        if(iskradesc)
        {
            mandatory = mandatory + "<br>KRA Description";
        }
         if(iskraweightage)
        {
            mandatory = mandatory + "<br>Weightage";
        }
         if(iskraManRate)
        {
            mandatory = mandatory + "<br>Manager Rating";
        }
         if(iskraManRateNo)
        {
            mandatory = mandatory + "<br> Manager Rating should be number";
         }
         if(iskraManComm)
         { 
            mandatory = mandatory + "<br>Manager Comment";
         }
         if( iskraEmpRate)
         {
            mandatory = mandatory + "<br>Employee Rating";
         }
         if(iskraEmpRateNo)
        {
            mandatory = mandatory + "<br>Employee Rating should be number";
        } 
         if(iskraEmpComm)
        {
            mandatory = mandatory + "<br>Employee Comment";
        }  
        //KPI list validated while adding KPI under KRA

        if (mandatory == "" && invalid == "" && functional == "") {
            return true;
        } else {
            var msg = "";
            if (mandatory != "") {
                msg = msg + "Please enter : " + mandatory;
                msg = msg + "<br>";
            }
            if (invalid != "") {
                msg = msg + "Please enter valid : " + invalid;
                msg = msg + "<br>";
            }
            if (functional != "") {
                msg = msg + functional;
            }
            this._sharedService.ShowMessage("error|" + msg);
        }
        return false;
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ReviewEmployee/ReviewSheet.component.ts
 **/